import React, { } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Card,
  Button,
  Dropdown,
  Row,
  Col,
  Badge,
  Tag,
  Space,
} from '@lockerpm/design';

import {
  DashOutlined,
  EditOutlined,
  PoweroffOutlined,
  ReloadOutlined,
  DeleteOutlined,
} from "@ant-design/icons";

import { gray } from '@ant-design/colors';

import itemsComponents from "../../../../../components/items";

import {
  accessKeyPermission,
  accessKeyStatus,
  timeFromNow,
} from '../../../../../utils/common'

const BoxData = (props) => {
  const { TextCopy } = itemsComponents;
  const { t } = useTranslation()
  const isAdmin = useSelector((state) => state.project.isAdmin)

  const {
    className = '',
    data = [],
    isCreate = false,
    onUpdate = () => {},
    onActive = () => {},
    onRegenerate = () => {},
    onDelete = () => {}
  } = props;

  const items = (item) => [
    {
      key: 'edit',
      icon: <EditOutlined />,
      label: <span>{t('button.edit')}</span>,
    },
    {
      key: 'active',
      icon: <PoweroffOutlined />,
      disabled: !item.activated && !isCreate,
      label: <span>{item.activated ? t('button.deactivate') : t('button.activate')}</span>,
    },
    {
      key: 'regenerate',
      icon: <ReloadOutlined />,
      label: <span>{t('button.regenerate')}</span>,
    },
    {
      key: 'delete',
      icon: <DeleteOutlined />,
      danger: true,
      label: <span>{t('button.delete')}</span>,
    }
  ].filter((i) => !i.hide)

  const dataFields = (d) => [
    {
      name: t('access_key.id'),
      lg: 8,
      value: <TextCopy
        value={d.id}
        color={gray[2]}
      />
    },
    {
      name: t('access_key.permission'),
      lg: 8,
      value: <Tag color={accessKeyPermission(d.editable).color}>
        <TextCopy
          value={t(accessKeyPermission(d.editable).label)}
          color={gray[2]}
        />
      </Tag>
    },
    {
      name: t('common.created_time'),
      lg: 8,
      value: <TextCopy
        value={timeFromNow(d.creation_date)}
        color={gray[2]}
      />
    },
    {
      name: t('common.last_used'),
      lg: 8,
      value: <TextCopy
        value={d.last_use_date ? timeFromNow(d.last_use_date) : ''}
        color={gray[2]}
      />
    },
    {
      name: t('common.restricted_ips'),
      lg: 8,
      value: <Space size={[4, 4]}>
        {
          d.restrict_ip.map((ip, index) => <Tag
            key={index}
            color="default"
          >
              <TextCopy
                value={ip}
                color={gray[2]}
              />
            </Tag>
          )
        }
      </Space>
    },
    {
      name: `${t('common.last_used')} ${t('common.client')}`,
      lg: 8,
      value: <TextCopy
        value={d.client_id}
        color={gray[2]}
      />
    },
  ]

  const handleClick = (key, item) => {
    if (key === 'delete') {
      onDelete(item)
    } else if (key === 'edit') {
      onUpdate(item)
    } else if (key === 'active') {
      onActive(item)
    } else {
      onRegenerate(item)
    }
  }

  return (
    <div className={className}>
      {
        data.map((d, index) => <Card
          key={d.id}
          className="mb-4"
          title={<div className="flex items-center justify-between">
            <div className="flex items-center">
              <p className="font-semibold mr-3">
                {`${t('access_key.title')} ${index + 1}`}
              </p>
              <Tag>
                <Badge
                  className="flex items-center"
                  style={{ color: gray[2]}}
                  status={accessKeyStatus(d.activated).color}
                  text={
                    <TextCopy
                      value={t(accessKeyStatus(d.activated).label)}
                      color={gray[2]}
                    />
                  }
                />
              </Tag>
            </div>
            {
              isAdmin && <Dropdown menu={{ items: items(d), onClick: (e) => handleClick(e.key, d) }}>
                <Button
                  size="small"
                  icon={<DashOutlined />}
                />
              </Dropdown>
            }
          </div>}
        >
          <Row gutter={[12, 24]}>
            {
              dataFields(d).map((f, i) => <Col
                key={i}
                lg={f.lg}
                md={12}
                sm={12}
                xs={12}
              >
              <p className="font-bold text-l mb-1">
                {f.name}
              </p>
              {f.value}
            </Col>)
            }
          </Row>
        </Card>)
      }
    </div>
  );
}

export default BoxData;
